import React from 'react'
import TabsProvider from '../tabs-provider'

const ShowDiscount = ({ params: { discountId }, location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
// @ts-ignore
      location={location}
      tabs={[{
        label: 'Edit Discount',
        path: `/ecommerce/discounts/${discountId}/edit`
      }]}
    />
    {children}
  </div>
)

export default ShowDiscount
